import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { AppState, injectUserBean } from '@store';
import { CommunityProfileType } from '../models/user';

@Component({
  selector: 'app-not-found',
  imports: [TranslatePipe],
  template: `
    <div class="container-page">
      <div class="rounded-circle not-found text-white">
        <div class="my-4 mx-auto" style="width:60%">
          <h3>{{ 'WEB_404_TITLE' | translate }}</h3>
        </div>
        <div class="my-4 mx-auto" style="width:60%">
          {{ 'WEB_404_INFO' | translate }}
        </div>
        <button type="button" (click)="backHome()">
          {{ 'WEB_ACTIONS_BACK_HOME' | translate }}
        </button>
      </div>
    </div>
  `,
  styles: `
    .not-found {
      background: rgba(0, 0, 0, 0.5);
      width: 500px;
      height: 500px;
      margin: 0 auto;
      margin-block-start: 100px;
      text-align: center;
      padding-block-start: 100px;

      button {
        background: transparent;
        border: 1px solid #fff;
        color: #fff;
        width: 200px;
        padding: 15px;
        margin-block-start: 20px;

        &:hover {
          background: rgba(0, 0, 0, 0.5);
        }
      }
    }
  `,
})
export class NotFoundComponent {
  store = inject<Store<AppState>>(Store);
  router = inject(Router);

  userBean = injectUserBean();

  backHome = () => {
    const { communityStatus, communityProfileId } = this.userBean();
    const home =
      communityProfileId === CommunityProfileType.PROJECT_ROOM
        ? '/rooms'
        : '/home';

    this.router.navigate([communityStatus === 3 ? '/billing' : home]);
  };
}
